import { useNumberFormatSelector } from "@redux/reducers/appConfig";
import { getFormattedNumber } from "@shared/v2/lib/getFormattedNumber";

export const useGetFormattedNumber = () => {
  const format = useNumberFormatSelector();

  return number => getFormattedNumber(number, format);
};
